import axios from "axios";
import * as Sentry from '@sentry/react';
import { getToken, getTokenHeader } from "../../../../screen/auth/action";
import { getNetworkListURL, getNetworkPerformanceURL, getNetworkRewardURL, getNetworkSummaryURL } from "../urls";

export const getNetworkListAction = async (payload) => {
  try {
    const params = new URLSearchParams(payload);
    const token = await getToken();
    const { data } = await axios.get(getNetworkListURL(), {
      params: params,
      ...getTokenHeader(token),
    });
    return data;
  } catch (err) {
    Sentry.captureException(err, {
      tags: { module: 'mynetwork', flow: 'getNetworkListAction' },
    });
    return { error: true, message: err.response?.data?.message || err.message };
  }
};
export const getNetworkSummaryAction = async (payload) => {
  try {
    const params = new URLSearchParams(payload);
    const token = await getToken();
    const { data } = await axios.get(getNetworkSummaryURL(), {
      params: params,
      ...getTokenHeader(token),
    });
    return data;
  } catch (err) {
    Sentry.captureException(err, {
      tags: { module: 'mynetwork', flow: 'getNetworkSummaryAction' },
    });
    return { error: true, message: err.response?.data?.message || err.message };
  }
};

export const getNetworkPerformanceAction = async (payload) => {
  try {
    const params = new URLSearchParams(payload);
    const token = await getToken();
    const { data } = await axios.get(getNetworkPerformanceURL(), {
      params: params,
      ...getTokenHeader(token),
    });
    return data;
  } catch (err) {
    Sentry.captureException(err, {
      tags: { module: 'mynetwork', flow: 'getNetworkPerformanceAction' },
    });
    return { error: true, message: err.response?.data?.message || err.message };
  }
};

export const getNetworkRewardAction = async (payload) => {
  try {
    const params = new URLSearchParams(payload);
    const token = await getToken();
    const { data } = await axios.get(getNetworkRewardURL(), {
      params: params,
      ...getTokenHeader(token),
    });
    return data;
  } catch (err) {
    Sentry.captureException(err, {
      tags: { module: 'mynetwork', flow: 'getNetworkRewardAction' },
    });
    return { error: true, message: err.response?.data?.message || err.message };
  }
};
